// mismos límites que backend/controllers/tarifas/service.go
export const LIMITES = {
  CONCEPTO_MAX: 250,
  DESCRIPCION_MAX: 2000,
  PREGUNTA_MAX: 255,
  PREGUNTAS_MAX: 20,
  PAQUETES_MAX: 20,
  COMPLEMENTOS_MAX: 20,
  PERSONAS_MESA_MAX: 100,
};

export const VENTA_MESA = { SILLA: "silla", MESA: "mesa" };
export const TIPO_COMPLEMENTO = { ADICIONAL: "adicional", SUGERIDA: "sugerida" };

export const paqueteVacio = () => ({ id: null, personas: "", precio: "" });
export const complementoVacio = (tipo) => ({ idtarifa: "", tipo, maximo_por_mesa: tipo === TIPO_COMPLEMENTO.ADICIONAL ? 1 : "" });

export const TIPO = { TICKET: 1, VOUCHER: 2 };

export const nombreTipo = (idtipo) => (idtipo === TIPO.TICKET ? "Ticket" : "Consumición");

export const COLOR_POR_DEFECTO = JSON.stringify({ r: 0.337, g: 0.337, b: 1, a: 1 });

export const preguntaVacia = () => ({ informacion_adicional: "", obligatoria: true });

export const tarifaVacia = (idtipo, { hayUbicaciones = false } = {}) => ({
  id: null,
  idtipo,
  concepto: "",
  descripcion: "",
  precio: "",
  privado: false,
  inicio_venta: "",
  fin_venta: "",
  fechas: [],
  // tickets: la ubicación define sus límites
  idubicacion: "",
  nueva_ubicacion: !hayUbicaciones,
  nombre_ubicacion: "",
  // tanda: se vende recién cuando esta otra tarifa se agota o termina su venta
  por_tandas: false,
  idtarifa_previa: "",
  // vouchers: límites propios; en un ticket nuevo, los de la ubicación nueva
  limite_persona: 10,
  limite_maximo: 100,
  asumir_comision: false,
  requiere_aprobacion: false,
  informacion_adicional: false,
  preguntas: [preguntaVacia()],
  preimpreso: false,
  consalidas: false,
  imprimeqr: true,
  unidadstock: 1,
  color: COLOR_POR_DEFECTO,
  formato: "tarjeta",
  copiar_diseno_de: null,
  // tickets en ubicaciones con mesas: por silla o la mesa entera, con
  // paquetes por cantidad de personas y complementos (adicionales y sugeridas)
  venta_mesa: VENTA_MESA.SILLA,
  paquetes: [],
  complementos: [],
});
